var map = {
	"./Regulamin.pdf": 65,
	"./ambasada.svg": 78,
	"./android-store.png": 90,
	"./apteka.svg": 79,
	"./awaria-samochodu.svg": 80,
	"./beep-01a.mp3": 151,
	"./bg.jpg": 152,
	"./bg.png": 153,
	"./dots.svg": 55,
	"./en.png": 154,
	"./en.svg": 42,
	"./formularze.svg": 56,
	"./fr.png": 155,
	"./fr.svg": 43,
	"./granica.svg": 81,
	"./help logo.svg": 82,
	"./hospital.jpg": 156,
	"./hospital2.jpg": 157,
	"./hospital3.jpg": 158,
	"./info-solid.svg": 51,
	"./kradziez.svg": 83,
	"./lekarz.svg": 84,
	"./leki.svg": 28,
	"./logo.png": 29,
	"./nagly-wypadek-zdrowotny.svg": 85,
	"./pl.png": 159,
	"./pl.svg": 44,
	"./prawnik.svg": 86,
	"./ru.png": 160,
	"./ru.svg": 45,
	"./sidebar-bg.png": 161,
	"./szpital.svg": 87,
	"./tlumacz.svg": 38,
	"./unlock-alt-solid.svg": 64,
	"./ustawienia.svg": 46,
	"./wypadek-samochodowy.svg": 88,
	"./wzory_10.pdf": 162
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 150;